import React, { useMemo } from 'react';
import { UITextarea, UIButton, UIInput } from '@tencent/dz-bricks-ui';
import { useComponents } from '@tencent/dz-elements';
import { MessageType } from '@tencent/dz-models';
import { FormContainer, FormItem, PhoneItem } from '../../../components';
import { useMessageModel, useMobileModel, useMessageById, useConsultModel } from '../../../hooks';
import { useFormService } from './useFormService';
var Form = function (props) {
    var messageState = useMessageById(props.messageId);
    var reportModuleParams = messageState.payload.reportModuleParams;
    var _a = useFormService(props.messageId), name = _a.name, phone = _a.phone, modalVisible = _a.modalVisible, checked = _a.checked, content = _a.content, hanleNameChange = _a.hanleNameChange, handlePhoneChange = _a.handlePhoneChange, handleContentChange = _a.handleContentChange, onSubmitPhone = _a.onSubmitPhone, handleSubmit = _a.handleSubmit, valid = _a.valid, hanldePopupOk = _a.hanldePopupOk, hanldePopupCancel = _a.hanldePopupCancel, handleToggle = _a.handleToggle;
    var View = useComponents().View;
    var autoPhoneEnabled = useMobileModel().autoPhoneEnabled;
    var messageModel = useMessageModel();
    var consultModel = useConsultModel();
    var isFeed = consultModel.isFeedConsult();
    var buttonDisabled = function () { return messageModel.leaveMessageSendTag || (autoPhoneEnabled && !checked); };
    var _b = useMemo(function () {
        var _a;
        if (!isFeed) {
            return {
                title: '免费获得诊疗方案',
                tips: ['您的信息将被保密，请放心填写', '专业咨询师跟进，一对一服务'],
            };
        }
        return {
            title: ((_a = messageState.payload) === null || _a === void 0 ? void 0 : _a.title) || '',
            tips: messageState.type === MessageType.OfflineForm ? ['您好，若处于排队中状态或遇客服长时间没回复您，请先输入您要咨询的信息和联系方式，我们会尽快与您联系。'] : [],
        };
    }, [isFeed, messageState]), title = _b.title, tips = _b.tips;
    return (React.createElement(View, { className: "from_" + reportModuleParams.module_type + " source_id_" + reportModuleParams.module_id },
        React.createElement(FormContainer, { title: title, tips: tips },
            isFeed && React.createElement(FormItem, { label: "\u59D3\u540D" },
                React.createElement(UIInput, { type: "text", placeholder: "\u8BF7\u8F93\u5165\u60A8\u7684\u59D3\u540D", maxLength: 10, onChange: hanleNameChange, value: name, style: { height: 30 } })),
            React.createElement(FormItem, { label: isFeed ? '电话' : '', requiredMark: true },
                React.createElement(PhoneItem, { handlePhoneChange: handlePhoneChange, phone: phone, btnText: "\u6388\u6743\u4F7F\u7528\u672C\u673A\u53F7\u7801", onSubmitPhone: onSubmitPhone, modalVisible: modalVisible, checked: checked, valid: valid, hanldePopupOk: hanldePopupOk, hanldePopupCancel: hanldePopupCancel, handleToggle: handleToggle })),
            React.createElement(FormItem, { label: isFeed ? '留言' : '意向内容' },
                React.createElement(UITextarea, { onChange: handleContentChange, value: content, placeholder: "\u8BF7\u8F93\u5165\u60A8\u8981\u54A8\u8BE2\u7684\u95EE\u9898" })),
            React.createElement(UIButton, { onClick: handleSubmit, style: { flexGrow: 1, height: 30 }, disabled: buttonDisabled() }, "\u63D0\u4EA4"))));
};
export default Form;
